const HERMES_WEBHOOK_URL = import.meta.env.VITE_HERMES_WEBHOOK_URL;
const EVOLUTION_API_URL = import.meta.env.VITE_EVOLUTION_API_URL;
const EVOLUTION_API_KEY = import.meta.env.VITE_EVOLUTION_API_KEY;
const EVOLUTION_INSTANCE = import.meta.env.VITE_EVOLUTION_INSTANCE;

export interface FormPayload {
  [key: string]: unknown;
}

export async function handleFormSubmit(formData: FormPayload, leadSource: string) {
  const payload = {
    event: "lead_captured",
    leadSource,
    data: {
      name: formData.name || "",
      email: formData.email || "",
      phone: formData.phone || "",
      organization: formData.organization || formData.schoolName || formData.company || "",
      role: formData.role || "",
      message: formData.message || "",
      customFields: Object.fromEntries(
        Object.entries(formData).filter(
          ([key]) => !["name", "email", "phone", "organization", "schoolName", "company", "role", "message"].includes(key)
        )
      ),
    },
    context: {
      pageUrl: window.location.href,
      submittedAt: new Date().toISOString(),
      userAgent: navigator.userAgent,
      utm_source: new URLSearchParams(window.location.search).get("utm_source") || undefined,
      utm_medium: new URLSearchParams(window.location.search).get("utm_medium") || undefined,
      utm_campaign: new URLSearchParams(window.location.search).get("utm_campaign") || undefined,
    },
  };

  // 1. Send to Hermes webhook
  if (HERMES_WEBHOOK_URL) {
    try {
      await fetch(HERMES_WEBHOOK_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
    } catch (err) {
      console.error("Hermes webhook failed:", err);
    }
  }

  // 2. Send thank-you WhatsApp via Evolution API
  const phone = (formData.phone as string) || "";
  if (phone && EVOLUTION_API_URL && EVOLUTION_INSTANCE) {
    try {
      const cleanPhone = phone.replace(/\D/g, "").replace(/^0/, "234");
      await fetch(`${EVOLUTION_API_URL}/message/sendText/${EVOLUTION_INSTANCE}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "apikey": EVOLUTION_API_KEY,
        },
        body: JSON.stringify({
          number: cleanPhone,
          text: `Hi ${formData.name || "there"}! 👋 Thanks for reaching out to Oyinbatfo. We've received your request for ${leadSource.replace(/_/g, " ")}. Our team will contact you within 2 hours. For urgent needs, reply here.`,
        }),
      });
    } catch (err) {
      console.error("WhatsApp send failed:", err);
    }
  }

  // 3. Track conversions
  if (typeof window !== "undefined") {
    if ((window as unknown as Record<string, unknown>).fbq) {
      (window as unknown as Record<string, (...args: unknown[]) => void>).fbq("track", "Lead", { source: leadSource });
    }
    if ((window as unknown as Record<string, unknown>).gtag) {
      (window as unknown as Record<string, (event: string, action: string, params?: Record<string, unknown>) => void>).gtag("event", "form_submit", { source: leadSource });
    }
  }

  return { success: true };
}
